import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

/**
 * ClientForce page header: brand icon tile, title, one-line description, and the
 * page's primary actions on the right.
 */
export function PageHeader({
  title,
  description,
  icon: Icon,
  actions,
  titleId,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  icon?: LucideIcon;
  actions?: ReactNode;
  titleId?: string;
  className?: string;
}) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-start justify-between gap-4', className)}>
      <div className="flex min-w-0 items-start gap-4">
        {Icon ? (
          <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-[14px] bg-primary text-primary-foreground shadow-[0_10px_24px_-10px_rgb(var(--primary)/0.7)] sm:inline-flex">
            <Icon className="h-6 w-6" aria-hidden="true" />
          </span>
        ) : null}
        <div className="min-w-0">
          <h1 id={titleId} className="m-0 break-words">
            {title}
          </h1>
          {description ? <p className="muted mt-1 text-sm">{description}</p> : null}
        </div>
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </div>
  );
}
